
export type LayoutPlatformType = 'desktop' | 'mobile';
export const DEFAULT_PLATFORM_TYPE: LayoutPlatformType = 'desktop';

export type ConfigurableDropdownOption<T = Record<string, any>> = {
  id: string;
  text: string;
} & T;

export type StudioLayoutTab = {
  label: string;
  fields: string[][];
  deletable?: boolean;
  editable?: boolean;
}